import React from 'react';
import ReactDOM from 'react-dom/client';
import Leanplum from 'leanplum-sdk';
import * as Sentry from '@sentry/react';
import { APP_INFO, IS_PROD, LEANPLUM_CONFIG, SENTRY_DNS } from 'config';
import EventReporter from 'lib/EventsProvider';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

EventReporter.initialize();

if (IS_PROD) {
  Leanplum.setAppIdForProductionMode(LEANPLUM_CONFIG.APP_ID, LEANPLUM_CONFIG.KEY);
} else {
  Leanplum.setAppIdForDevelopmentMode(LEANPLUM_CONFIG.APP_ID, LEANPLUM_CONFIG.KEY);
}
Leanplum.start();
if (!IS_PROD) {
  window.Kinedu.Leanplum = Leanplum;
}

Sentry.init({
  dsn: SENTRY_DNS,
  integrations: [],
  environment: APP_INFO.Env,
  release: APP_INFO.version,
  tracesSampleRate: 0.0,
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,
  tracePropagationTargets: [/api.kinedu.com/],
  normalizeDepth: 2,
});


root.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
